const homeDomain = (() => {
    const references = window.location.host;
    // 公司網址
    const company = references.includes('localhost')?'evtravel':references.split('.')[0];
    const companyDomainMaster = `${company}.tourcenter.com.tw`;
    const companyDomainTest = `${company}.ubbc.liontravel.com`;

    switch (process.env.ENV) {
        case 'prod':
            return `//${companyDomainMaster}`;
        default:
            return `//${companyDomainTest}`;
    }
})();

export { homeDomain };
